__turbopack_context__.v({
  "DM_12_24_Link_B": "Link-module-scss-module__NgbtIG__DM_12_24_Link_B",
  "DM_14_24_Link_B": "Link-module-scss-module__NgbtIG__DM_14_24_Link_B",
  "DM_20_24_Bold": "Link-module-scss-module__NgbtIG__DM_20_24_Bold",
  "DM_Body_Reg_16": "Link-module-scss-module__NgbtIG__DM_Body_Reg_16",
  "DM_Bold_14_16": "Link-module-scss-module__NgbtIG__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "Link-module-scss-module__NgbtIG__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "Link-module-scss-module__NgbtIG__DM_Bold_16_24",
  "DM_Bold_20_24": "Link-module-scss-module__NgbtIG__DM_Bold_20_24",
  "DM_Bold_40_56": "Link-module-scss-module__NgbtIG__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "Link-module-scss-module__NgbtIG__DM_Btn_16_16_Med",
  "DM_Med_10_12": "Link-module-scss-module__NgbtIG__DM_Med_10_12",
  "DM_Med_12_12_Chip": "Link-module-scss-module__NgbtIG__DM_Med_12_12_Chip",
  "DM_Med_12_16": "Link-module-scss-module__NgbtIG__DM_Med_12_16",
  "DM_Med_14_16": "Link-module-scss-module__NgbtIG__DM_Med_14_16",
  "DM_Med_14_20": "Link-module-scss-module__NgbtIG__DM_Med_14_20",
  "DM_Med_14_24": "Link-module-scss-module__NgbtIG__DM_Med_14_24",
  "DM_Med_16_16": "Link-module-scss-module__NgbtIG__DM_Med_16_16",
  "DM_Med_16_24": "Link-module-scss-module__NgbtIG__DM_Med_16_24",
  "DM_Med_18_24": "Link-module-scss-module__NgbtIG__DM_Med_18_24",
  "DM_Med_20_24": "Link-module-scss-module__NgbtIG__DM_Med_20_24",
  "DM_Med_24_24": "Link-module-scss-module__NgbtIG__DM_Med_24_24",
  "DM_Med_32_32": "Link-module-scss-module__NgbtIG__DM_Med_32_32",
  "DM_Med_32_48": "Link-module-scss-module__NgbtIG__DM_Med_32_48",
  "DM_Med_8_8": "Link-module-scss-module__NgbtIG__DM_Med_8_8",
  "DM_Reg_10_10": "Link-module-scss-module__NgbtIG__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "Link-module-scss-module__NgbtIG__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "Link-module-scss-module__NgbtIG__DM_Reg_12_16",
  "DM_Reg_14_16": "Link-module-scss-module__NgbtIG__DM_Reg_14_16",
  "DM_Reg_14_24": "Link-module-scss-module__NgbtIG__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "Link-module-scss-module__NgbtIG__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "Link-module-scss-module__NgbtIG__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "Link-module-scss-module__NgbtIG__DM_Reg_16_20",
  "DM_Reg_16_24": "Link-module-scss-module__NgbtIG__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "Link-module-scss-module__NgbtIG__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "Link-module-scss-module__NgbtIG__DM_Reg_18_28",
  "DM_Reg_32_32": "Link-module-scss-module__NgbtIG__DM_Reg_32_32",
  "DM_Reg_40_56": "Link-module-scss-module__NgbtIG__DM_Reg_40_56",
  "black": "Link-module-scss-module__NgbtIG__black",
  "blue": "Link-module-scss-module__NgbtIG__blue",
  "disableHover": "Link-module-scss-module__NgbtIG__disableHover",
  "grey": "Link-module-scss-module__NgbtIG__grey",
  "inline": "Link-module-scss-module__NgbtIG__inline",
  "large": "Link-module-scss-module__NgbtIG__large",
  "largeNormal": "Link-module-scss-module__NgbtIG__largeNormal",
  "link": "Link-module-scss-module__NgbtIG__link",
  "linkContent": "Link-module-scss-module__NgbtIG__linkContent",
  "medium": "Link-module-scss-module__NgbtIG__medium",
  "small": "Link-module-scss-module__NgbtIG__small",
  "underline": "Link-module-scss-module__NgbtIG__underline",
  "white": "Link-module-scss-module__NgbtIG__white",
});
